export default {
  'DE-CH': "Deutsch (CH)",
  'DE-DE': "Deutsch (DE)",
  'EN-GB': "English",
  'ES-ES': "Español",
  'FR-FR': "Français",
  'IT-IT': "Italiano",
  'NL-NL': "Nederlands",
};
